import { Box, Link, Stack, TableCell, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { getSecurityAsync, getSecurityKey } from '../../util/security'
import { Exchange } from '../../proto/generated/common'
import { LOGOS_BASE_URL } from '../../assets/constants'
import CircularSymbol from '../common/CircularAvatar'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'

interface Props {
    symbol: string
    onClick: () => void
    exchange: Exchange
}

const SymbolTableCell: React.FC<Props> = ({ symbol, onClick, exchange }) => {
    const [security, setSecurity] = useState<Awaited<ReturnType<typeof getSecurityAsync>>>(undefined)
    const secKey = getSecurityKey(exchange, symbol)
    useEffect(() => { if (secKey) getSecurityAsync(secKey).then(setSecurity); else setSecurity(undefined) }, [secKey])
    const data = [security?.symbol || symbol, security?.logoUrl || 'null']

    return (
        <TableCell  style={{ paddingLeft: '4px', paddingRight: 0, paddingTop: '0px', paddingBottom: '0px' , width: 180, minWidth: 180, maxWidth: 180}} key={symbol}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                <div
                    style={{
                        marginRight: '8px',
                        height: '20px',
                        width: '20px'
                    }}
                >
                    {data[1] && data[1] !== 'null' ? (
                        <img
                            style={{
                                margin: 0,
                                height: '20px',
                                width: '20px',
                                borderRadius: '50%',
                                padding: 0
                            }}
                            src={`${LOGOS_BASE_URL}${data[1]}.svg`}
                            alt={'Security Icon'}
                        />
                    ) : (
                        <CircularSymbol marginLeft={0} marginBT={0} marginRight={0} symbol={data[0]} width={'20px'} height={'20px'} />
                    )}
                </div>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        justifyContent: 'center'
                    }}
                >
                    {[data[0]].map((t, i) => {
                        return (
                            <Link
                                key={i}
                                color="inherit"
                                style={{ cursor: 'pointer' }}
                                sx={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    textDecoration: 'none',
                                    '&:hover': {
                                        color: (theme) => theme.palette.info.main
                                    },
                                    '&:hover .open-new-icon': {
                                        visibility: 'visible !important',
                                        color: (theme) => theme.palette.info.main
                                    }
                                }}
                                underline="none"
                                onClick={onClick}
                            >
                                <Stack direction="row" spacing={1} alignItems="center">
                                    <Typography
                                        variant={'body1'}
                                        sx={{
                                            fontSize: '14px',
                                            lineHeight: 1,
                                            overflow: 'hidden',
                                            whiteSpace: 'nowrap',
                                            textOverflow: 'ellipsis'
                                        }}
                                    >
                                        {t}
                                    </Typography>
                                    <OpenInNewIcon
                                        className="open-new-icon"
                                        sx={{
                                            fontSize: 14,
                                            color: 'inherit',
                                            visibility: 'hidden',
                                            marginLeft: '4px'
                                        }}
                                    />
                                </Stack>
                            </Link>
                        )
                    })}
                </Box>
            </Box>
        </TableCell>
    )
}

export default SymbolTableCell
